export default __webpack_public_path__ + "static/media/closet5-after1-768w.d3827aa7.avif";